import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { CSSTransition } from "react-transition-group";

import { getPageData } from "../../assets/js/getData";

import styleObj from "./style.module.scss";
import "./style.scss";
import Dialog from "../dialog";
import navList from "../../router";
import Nav2021 from "./2021";

function getStatus(status) {
  switch (status) {
    case 0:
      return "(未开始)";
    case 1:
      return "(报名中)";
    default:
      return "";
  }
}

function getDateTime(timeStr) {
  return new Date(timeStr).getTime();
}

function getCommonTime(time) {
  let issafariBrowser =
    /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
  return issafariBrowser ? time.replace(/-/g, "/") : time;
}

class MyNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      init: false,
      list: navList,
      is2021: false,
    };
    this.preventClick = this.preventClick.bind(this);
  }
  render() {
    let { init, list, is2021 } = this.state;
    return (
      <CSSTransition
        in={init}
        classNames="nav-init"
        timeout={1200}
        unmountOnExit
      >
        {is2021 ? (
          <>
            <Nav2021 list={list} />
          </>
        ) : (
          <div className={styleObj["nav-wrap"]}>
            <div className={styleObj["nav"]}>
              {list.map((item) => (
                <NavLink
                  key={item.path}
                  exact
                  to={item.path}
                  className={item.status === 0 ? styleObj["will-open"] : ""}
                  activeClassName={styleObj["on"]}
                  onClick={(e) => {
                    this.preventClick(e, item.isPrevent);
                  }}
                >
                  <p>{item.name}</p>
                  {
                    <p className={styleObj["status"]}>
                      {item.timeEnd ? item.timeEnd.split(" ")[0] : ""}
                    </p>
                  }
                  <p className={styleObj["status"]}>{getStatus(item.status)}</p>
                </NavLink>
              ))}
            </div>
          </div>
        )}
      </CSSTransition>
    );
  }

  onInit = (route) => {
    if (route.meta?.is2021) {
      this.setState({
        is2021: true,
      });
    } else {
      this.setState({
        is2021: false,
      });
    }
  };

  curRoute = (path) => {
    const [route] = navList.filter((nav) => nav.path === path);
    return route;
  };

  componentDidMount() {
    this.props.history.listen(({ pathname }) => {
      const route = this.curRoute(pathname);
      this.onInit(route);
    });
    this.onInit(this.curRoute(this.props.location.pathname));

    getPageData().then((data) => {
      const nowTime = new Date().getTime();
      navList.forEach((x) => {
        data.forEach((y) => {
          if (x.label === y.name) {
            x.timeStart = getCommonTime(y.form.timeStart);
            x.timeEnd = getCommonTime(y.form.timeEnd);

            if (
              !x.timeStart ||
              !x.timeEnd ||
              nowTime < getDateTime(x.timeStart)
            ) {
              x.isPrevent = true;
              x.status = 0;
            } else if (
              nowTime > getDateTime(x.timeStart) &&
              nowTime <= getDateTime(x.timeEnd)
            ) {
              x.isPrevent = false;
              x.status = 1;
            } else if (nowTime > getDateTime(x.timeEnd)) {
              x.isPrevent = false;
              x.status = 2;
            }
          }
        });
      });
      this.setState({
        init: true,
        list: navList,
      });
    });
  }
  preventClick(e, isPrevent) {
    console.log("isPrevent: ", isPrevent);

    if (isPrevent) {
      Dialog("活动尚未开始，敬请期待~").show();
      e.preventDefault();
      // window.open('http://www.jiguo.com/event/index/3706.html','__target')
    }
  }
}

export default withRouter(MyNav);
